/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {usePrimeCache} from "./ServiceHooks";
import {
    useCallback,
    useMemo
} from "react";

// Hook that returns a filter function to exclude items
// based on their project status codes.
export const useFilterByServiceProperty = (service, values, searchByProperty = 'code') => {
    const loaded = usePrimeCache([service]);
    
    const excludedProjectStatusIds = useMemo(() => {
            if(!loaded || !values?.length) { return []; }
            return values.map(
                value => {
                    const model = service.CachedValueByProperty(value, searchByProperty)?.result;
                    const primaryKeyValue = service.GetPrimaryKey(model);
                    return Number(primaryKeyValue);
                }
            )?.filter(Boolean) ?? [];
        }, [service, searchByProperty, values, loaded]
    );
    
    return useCallback((item) => {
        return excludedProjectStatusIds.includes(Number(service.GetPrimaryKey(item)));
    }, [excludedProjectStatusIds, service]);
}
